'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidWatchPath = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // Usage:
//
// hotZone(c)
//
// hotZone(c, {
//   modelA: modelA,
//   modelB: modelB
// })
//
// hotZone(c, {
//   name: {
//     from: model,
//     watch: ['name']
//   },
//   value: {
//     from: model,
//     watch: ['value']
//   }
// })
//


exports.spreadWatchPath = spreadWatchPath;
exports.standardizeAttrOption = standardizeAttrOption;
exports.default = hotZone;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _modula = require('modula');

var _immutable = require('modula/dist/immutable');

var _hot_zone_context = require('./hot_zone_context');

var _hot_zone_context2 = _interopRequireDefault(_hot_zone_context);

var _display_name = require('./display_name');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hotZoneDebug = (0, _debug2.default)('modula-react:hotzone');

var flipAppend = (0, _ramda.flip)(_ramda.append);

function keysOfSubject(subject) {
  if ((0, _modula.isModel)(subject)) {
    return (0, _ramda.keys)(subject.props());
  } else if ((0, _immutable.isImmutableType)(subject)) {
    return subject.keySeq().toJS();
  } else if ((0, _ramda.is)(Array, subject)) {
    return (0, _ramda.times)(_ramda.identity, subject.length);
  } else {
    // Object
    return (0, _ramda.keys)(subject);
  }
}

var spreadOne = function spreadOne(model, nextPath) {
  return function (subjectPath) {
    var subject = model.getIn(subjectPath);

    if (nextPath === '*') {
      return (0, _ramda.map)(flipAppend(subjectPath), keysOfSubject(subject));
    } else if ((0, _ramda.is)(Array, nextPath)) {
      return (0, _ramda.map)(flipAppend(subjectPath), nextPath);
    } else {
      return [flipAppend(subjectPath, nextPath)];
    }
  };
};

var mergeResults = function mergeResults(calculate) {
  return function (result, nextArg) {
    return (0, _ramda.concat)(result, calculate(nextArg));
  };
};

var handleNextPath = function handleNextPath(from) {
  return function (currentWatchPaths, nextPath) {
    return (0, _ramda.reduce)(mergeResults(spreadOne(from, nextPath)), [], currentWatchPaths);
  };
};

// spread array and '*' in watch path
// given ['counters', [0, 1]]
// returns [['counters', 0], ['counters', 1]]
function spreadWatchPath(_ref) {
  var from = _ref.from,
      watch = _ref.watch;

  var fromPath = (0, _modula.getPathFromRoot)(from);

  var paths = (0, _ramda.reduce)(handleNextPath(from), [[]], watch);

  return (0, _ramda.map)((0, _ramda.concat)(fromPath), paths);
}

var getWatchPaths = (0, _ramda.pipe)(_ramda.values, (0, _ramda.map)(spreadWatchPath), (0, _ramda.reduce)(_ramda.concat, []), _ramda.uniq);

var getNewValue = function getNewValue(getStateInPath) {
  return function (_ref2) {
    var from = _ref2.from,
        get = _ref2.get;

    var fromPath = (0, _modula.getPathFromRoot)(from);
    var newModel = getStateInPath(fromPath);

    return get(newModel);
  };
};

var isNotEmpty = function isNotEmpty(item) {
  return (0, _ramda.not)((0, _ramda.isEmpty)(item));
};

var isArrayOfStrings = (0, _ramda.allPass)([(0, _ramda.is)(Array), isNotEmpty, (0, _ramda.all)((0, _ramda.is)(String))]);

var isValidPathItem = (0, _ramda.anyPass)([isArrayOfStrings, (0, _ramda.is)(String), (0, _ramda.is)(Number), (0, _ramda.equals)('*')]);

var isValidWatchPath = exports.isValidWatchPath = (0, _ramda.all)(isValidPathItem);

function standardizeAttrOption(name, option) {
  if ((0, _modula.isModel)(option)) {
    return {
      from: option,
      watch: [],
      get: _ramda.identity
    };
  } else if ((0, _ramda.isNil)(option) || (0, _ramda.is)(Array, option)) {
    throw new Error('option is neither modula model or an object for hotZone attr "' + name + '"');
  } else if (!(0, _modula.isModel)(option.from)) {
    throw new Error('"from" in the option is not a modula model for hotZone attr "' + name + '"');
  } else if (option.watch && !isValidWatchPath(option.watch)) {
    throw new Error('"watch" in the option is not one of array,  for hotZone attr "' + name + '"');
  } else {
    var finalWatch = option.watch || [];

    return (0, _ramda.merge)({
      get: function get(m) {
        return m.getIn(finalWatch);
      },
      watch: []
    }, option);
  }
}

function hotZone(DecoratedComponent) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  return function (props) {
    return _react2.default.createElement(
      _hot_zone_context2.default.Consumer,
      null,
      function (_ref3) {
        var registerZone = _ref3.registerZone,
            unregisterZone = _ref3.unregisterZone,
            getStateInPath = _ref3.getStateInPath;

        function finalAttrs() {
          if (attrs === undefined) {
            // default from extract path from model
            return {
              model: {
                from: props.model,
                watch: [],
                get: _ramda.identity
              }
            };
          } else {
            return (0, _ramda.fromPairs)((0, _ramda.map)(function (_ref4) {
              var _ref5 = _slicedToArray(_ref4, 2),
                  name = _ref5[0],
                  option = _ref5[1];

              return [name, standardizeAttrOption(name, option)];
            }, (0, _ramda.toPairs)(attrs)));
          }
        }

        var Wrapper = function (_Component) {
          _inherits(Wrapper, _Component);

          function Wrapper() {
            _classCallCheck(this, Wrapper);

            return _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).apply(this, arguments));
          }

          _createClass(Wrapper, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
              var _this2 = this;

              hotZoneDebug('watch paths', getWatchPaths(finalAttrs()));

              (0, _ramda.forEach)(function (propPath) {
                registerZone(propPath, _this2);
              }, getWatchPaths(finalAttrs()));
            }
          }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps() {
              // TODO handle parent refresh
            }
          }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              var _this3 = this;

              (0, _ramda.forEach)(function (propPath) {
                unregisterZone(propPath, _this3);
              }, getWatchPaths(finalAttrs()));
            }
          }, {
            key: 'render',
            value: function render() {
              var finalProps = (0, _ramda.merge)(props, (0, _ramda.map)(getNewValue(getStateInPath), finalAttrs()));

              hotZoneDebug('rendering with props', finalProps);

              return _react2.default.createElement(DecoratedComponent, finalProps);
            }
          }]);

          return Wrapper;
        }(_react.Component);

        Wrapper.displayName = (0, _display_name.wrapDisplayName)(DecoratedComponent, 'hotZone');

        return _react2.default.createElement(Wrapper, null);
      }
    );
  };
}